const id_payment_credit = {
    "": "hutang",
    add: "tambah hutang",
    detail: "detail hutang",
    info_title: "Halaman ini digunakan untuk melakukan pembayaran tagihan.",
    inv_pay: "tagihan dibayar",
    inv_remainning: "sisa tagihan",
    total_inv: "total tagihan",
    total_selected: "total dipilih",

    label: {
        bank: "rekening bank",
        cut: "potongan",
        giro_bank: "nama bank giro",
        giro_date: "tanggal pencairan giro",
        giro_info: "keterangan pencairan giro",
        giro_no: "nomor giro",
        nominal: "nominal pembayaran",
        return: "retur",
        select_invoice: "pilih tagihan",
        selected_invoice: "tagihan terpilih",
    },

    error: {
        account_bank: "Rekening bank tidak boleh kosong.",
        account_cut: "Potongan tidak boleh kosong.",
        create: "Gagal melakukan pembayaran.",
        dp: "Transaksi ini tidak menggunakan down payment.",
        dp2: "Down payment telah dibayarkan.",
        giro: "Nomor giro tidak boleh kosong.",
        inv_min: "Minimal terdapat 1 tagihan terpilih.",
        pay_method: "Metode pembayaran tidak boleh kosong.",
        pay_nominal: "Nominal pembayaran tidak boleh kosong.",
        pay_nominal_zero: "Nominal pembayaran tidak boleh 0 atau minus.",
        retur: "Retur tidak boleh kosong.",
    },

    success: {
        create: "Berhasil melakukan pembayaran.",
    },
}

export default id_payment_credit;